module.exports = __webpack_public_path__ + "img/bence-balla-schottner-deGn9vSwXIM-unsplash.5fd24cc2.jpg";